import { createStore } from 'satcheljs';
export default createStore('messageOption', {
    emptyDeletedItemsOnLogOut: null,
})();
//# sourceMappingURL=store.js.map